import { Component, Inject, OnInit, inject } from '@angular/core';
import { CollectionComponent } from '@components/abstract/collection.component';
import { CollectionFilter } from '@models/collection/collection-filter';
import { CollectionService } from '@services/common/collection.service';
import { CommonApiService } from '@services/common/common-api.service';
import { Community } from '@models/communities/community.model';
import { ICommunityService } from '@tokens/injection.tokens';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SortEvent } from '@models/collection/sort-event';
import { combineLatestWith } from 'rxjs';

@Component({ template: `` })
export abstract class CommunityCollectionComponent<T>
  extends CollectionComponent<T>
  implements OnInit
{
  communityService = inject(ICommunityService);
  community: Community | null = this.communityService.model;
  selected: T[] = [];
  collection: T[] = [];
  loading = true;
  protected constructor(
    router: Router,
    location: Location,
    api: CommonApiService,
    service: CollectionService<T>,
    @Inject('Limit') limit = 10,
    @Inject('OrderBy') orderBy: string | SortEvent = '',
    @Inject('Includes') includes: string[] = [],
    @Inject('Filters') filters: CollectionFilter[] = []
  ) {
    super(
      router,
      location,
      ``,
      api,
      service,
      limit,
      orderBy,
      includes,
      filters
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
    const observable = this.communityService.model$;
    const observable1 = this.service.collection$;
    const subscribe = observable
      .pipe(combineLatestWith(observable1))
      .subscribe(([community, collection]) => {
        this.loading = false;
        if (community) {
          this.community = community;
          this.collection = collection.data;
          this.load();
        }
      });
    this.unsubscribe.push(subscribe);
  }
  abstract load(): void;
}
